import './styles/cookieconsent.min.css'
import './styles/main.scss'
import svg4everybody from 'svg4everybody';
svg4everybody({polyfill: true});
import slideToggle from "./scripts/toggleSlide"
import LazyLoad from "vanilla-lazyload";
import { tns } from 'tiny-slider/src/tiny-slider';
import './scripts/excludeLinting/cookieconsent.min'
import './scripts/excludeLinting/cookie-layer'
import animateScrollTo from 'animated-scroll-to';

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (var i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

if (!Element.prototype.matches) {
    Element.prototype.matches = Element.prototype.msMatchesSelector ||
        Element.prototype.webkitMatchesSelector;
}

if (!Element.prototype.closest) {
    Element.prototype.closest = function(s) {
        var el = this;

        do {
            if (Element.prototype.matches.call(el, s)) return el;
            el = el.parentElement || el.parentNode;
        } while (el !== null && el.nodeType === 1);
        return null;
    };
}

function requireAll(r) {
    r.keys().forEach(r)
}
requireAll(require.context('./assets/icons/', true, /\.svg$/))

new LazyLoad({
    elements_selector: "img.lazy",
    threshold: 300
});

if (document.querySelectorAll('.image-slider-items').length > 0) {

    document.querySelectorAll('.image-slider').forEach(function(el) {
        let autoplay = {}
        if (el.dataset.autoplaytimeout > 0) {
            autoplay = {
                autoplay: true,
                autoplayHoverPause: true,
                autoplayTimeout: el.dataset.autoplaytimeout,
                autoplayButtonOutput: false
            }
        }
        new tns(Object.assign({
            container: el.querySelector('.image-slider-items'),
            controlsContainer: el.querySelector('.image-slider .arrow-controlls'),
            navContainer: el.querySelector('.image-slider .dot-controlls'),
            items: 1,
            mode: 'gallery',
            lazyload: true,
            speed: 1000
        }, autoplay))
    })

    window.addEventListener('load', () => {
        document.querySelectorAll('.image-slider-item img').forEach(function(el) {
            el.setAttribute('src', el.dataset.src)
        })
        document.querySelectorAll('.image-slider-item source').forEach(function(el) {
            el.setAttribute('srcset', el.dataset.srcset)
        })
    })
}

if (document.querySelectorAll('.opinion-container').length > 0) {
    new tns({
        container: '.opinion-items',
        controlsContainer: '.opinion-container .arrow-controlls',
        items: 3,
        mode: 'gallery',
        lazyload: true,
        speed: 700
    })
}

if (document.querySelectorAll('.news-slider-container').length > 0) {
    const width = window.outerWidth;
    let items = 3;

    if (width <= 1250) {
        items = 2
    }
    if (width <= 757) {
        items = 1
    }

    document.querySelectorAll('.news-slider-container').forEach(function (el) {
        const dots = el.querySelectorAll('.dot-controlls span');
        const countDots = dots.length;
        let countMaxDots = countDots / items;
        if ((items - 1) === countDots) {
            countMaxDots += 1;
        }

        for (let i = countDots - 1; i >= countMaxDots; i--) {
            dots[i].remove();
        }

        new tns(Object.assign({
            container: el.querySelector('.news-list-row'),
            controlsContainer: el.querySelector('.arrow-controlls'),
            navContainer: el.querySelector('.dot-controlls'),
            items: items,
            autoplay: false,
            "mouseDrag": true,
            "swipeAngle": false,
            "loop": false,
            lazyload: true,
            preventScrollOnTouch: 'force',
            speed: 400
        }))
    })
}

document.querySelectorAll('.animated-icon3').forEach(function(el) {
    el.addEventListener('click', () => {
        slideToggle(document.querySelector('.mobile-navi-wrapper'))
        el.classList.toggle('open')
    })
})

document.querySelectorAll('.mobile-navi li.has-children svg').forEach(function(el) {
    if (el.parentNode.classList.contains('open')) {
        //fix for active menu items. Closing of submenu is otherwise not smooth
        el.parentNode.querySelector('.submenu').style.display = 'block'
    }
    el.addEventListener('click', () => {
        if(hasClass(el.parentNode, 'open')) {
            slideToggle(el.parentNode.querySelector('.submenu'))
        } else {
            slideToggle(el.parentNode.querySelector('.submenu'))
        }
        el.parentNode.classList.toggle('open')
    })
})

document.querySelectorAll('.frame-type-accordion header').forEach(function(el) {
    el.addEventListener('click', () => {
        if(hasClass(el, 'active')) {
            slideToggle(el.closest('.frame-type-accordion-item').querySelector('.accordion-content'))
        } else {
            slideToggle(el.closest('.frame-type-accordion-item').querySelector('.accordion-content'))
        }
        el.parentNode.querySelectorAll('svg').forEach(function(child) {
            child.classList.toggle('active')
        })

    })
})

document.querySelectorAll('.frame-type-tabs .tabs-controlles header').forEach(function(el) {
    el.addEventListener('click', () => {
        if(!el.classList.contains('active')) {
            el.parentNode.querySelectorAll('header').forEach(function(child) {
                child.classList.remove('active')
            })
            el.classList.toggle('active')
            let index = Array.prototype.indexOf.call(el.parentNode.children, el)
            let contentItems = el.closest('.frame-type-tabs').querySelectorAll('.tabs-item-content-wrapper')
            contentItems.forEach(function(child) {
                child.classList.remove('active')
            })
            contentItems[index].classList.toggle('active')
        }
    })
})

window.addEventListener('scroll', () => {
    if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
        document.querySelector('body').classList.add('scrolled');
    } else {
        document.querySelector('body').classList.remove('scrolled');
    }
})

document.querySelector('.change-font').addEventListener('click', (e) => {
    e.preventDefault()
    document.querySelector('html').classList.toggle('bigger-font')
})

if (document.querySelector('.right-column-content')) {
    let sideMenu = document.querySelector('.right-column-content')
    var sticky = sideMenu.offsetTop + sideMenu.getBoundingClientRect().top + document.documentElement.scrollTop - 114
    const blueBlocks = document.querySelectorAll('.blue-content');
    window.addEventListener('scroll', () => {
        if (window.pageYOffset >= sticky) {
            checkBlueBlock(blueBlocks, sideMenu);
            sideMenu.classList.add('side-bar-fixed')
        } else {
            sideMenu.classList.remove('side-bar-fixed');
        }
    })
}

function checkBlueBlock(blueBlocks, sideMenu, level = 0)
{
    if (blueBlocks[level].offsetTop <= sideMenu.clientHeight + document.documentElement.scrollTop + 200) {
        sideMenu.classList.add('side-bar-hide')
    } else {
        sideMenu.classList.remove('side-bar-hide');
    }
}

document.querySelector('.scroll-to-top').addEventListener('click', () => {
    animateScrollTo(document.body, {speed: 100});
})

function hasClass(element, className) {
    return (' ' + element.className + ' ').indexOf(' ' + className+ ' ') > -1;
}